module.exports = __webpack_public_path__ + "img/gb00a_.prt.89e2063e.jpg";